<template>
  <div class="rightpanel-vacancies">
    <div v-if="vacancies.length" class="info-vac__content">
      <Vacancy v-for="(item, i) in vacancies" :key="i" :item="item" />
    </div>
    <Alert v-else class="empty" :text="errorText" />
  </div>
</template>

<script>
import Vacancy from 'Parts/Candidate/Details/Vacancy';
import { store } from '@/store';
import Alert from 'Elements/Alert/Alert';

export default {
  computed: {
    vacancies() {
      return store.state.rightPanel.panelMode == 'canditatePanel'
        ? store.state.rightPanel.metadata?.content?.data || []
        : [];
    },
    errorText() {
      return store.state.rightPanel.metadata?.content?.data.hasOwnProperty(
        'role_access'
      ) && !store.state.rightPanel.metadata?.content?.data?.role_access
        ? 'Доступ к списку вакансий ограничен настройками вашей роли'
        : 'Нет прикрепленных вакансий';
    }
  },
  components: { Vacancy, Alert }
};
</script>

<style lang="scss" scoped>
.rightpanel-vacancies {
  position: relative;
  height: 100vh;
}

.empty {
  max-width: 288px;
  margin: 16px;
  padding: 12px 13px 12px 16px;
}

.footer-bar {
  padding: 24px;
  border-top: 1px solid $black-20;
  vertical-align: bottom;
  align-items: stretch;
  flex-direction: column;
  display: flex;
  background-color: $white;
  position: absolute;
  bottom: 0;
  width: 100%;

  &__button {
    align-self: stretch;
    -ms-grid-row-align: stretch;
  }
}

.info-vac {
  align-items: center;
  border-bottom: 1px solid $black-20;
  display: flex;
  padding: 24px 0 24px 24px;

  &__text {
    font-size: 16px;
    line-height: 24px;
    color: $blue-100;
    margin-left: 4px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100% - 78px);
    -ms-overflow-style: none;
    background-color: $white;
  }
}

.space {
  color: $black-20;
  margin-top: 4px;
}
</style>
